// extracted by mini-css-extract-plugin
var _1 = "ProviderTableLayout-modulepageActions__cJNUD PageActions-modulePageActions__lL8Sl";
export { _1 as "pageActions" }
